module.exports = __webpack_public_path__ + "img/BuyAbilityImg2.9592e709.png";